<template>
    <div class="height-10 w-100 shadow-lg px-4 bg-brand-gradient">
        <div class="d-flex align-items-center container p-0">
            <div class="page-logo width-mobile-auto m-0 align-items-center justify-content-center p-0 bg-transparent bg-img-none shadow-0 height-9">
                <a href="/" class="page-logo-link press-scale-down d-flex align-items-center">
                    <img src="img/logo.png" alt="Social Intelligence" aria-roledescription="logo">
                    <span class="page-logo-text mr-1">Social Intelligence</span>
                </a>
            </div>
            <a href="register" class="btn-link text-white ml-auto" v-if="page=='login2'">
                Crear Cuenta
            </a>
            <span class="text-white opacity-50 ml-auto mr-2 hidden-sm-down" v-if="page=='register'">
                ¿Ya tiene cuenta?
            </span>
            <a href="login" class="btn-link text-white ml-auto ml-sm-0" v-if="page=='register'">
                Inicie Sesión
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        page: String
    }
}
</script>